import React, { useState } from 'react';
import { Button, Backdrop, CircularProgress, Typography, Box } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { useListContext, useDataProvider, useNotify } from 'react-admin';

interface SacopExportButtonProps {
    exporter: (records: any[]) => void;
}

const SacopExportButton = ({ exporter }: SacopExportButtonProps) => {
    const { filterValues, sort, resource } = useListContext();
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const [exporting, setExporting] = useState(false);

    const handleExport = async () => {
        setExporting(true);
        try {
            // Cargar todos los registros coincidentes con los filtros actuales
            const { data } = await dataProvider.getList(resource, {
                filter: filterValues,
                sort: sort,
                pagination: { page: 1, perPage: 10000 },
            });

            if (data && data.length > 0) {
                exporter(data);
                notify('Exportación completada con éxito', { type: 'success' });
            } else {
                notify('No hay datos para exportar', { type: 'warning' });
            }
        } catch (error) {
            console.error(error);
            notify('Error al generar la exportación', { type: 'error' });
        } finally {
            setExporting(false);
        }
    };

    return (
        <>
            <Button
                color="primary"
                onClick={handleExport}
                startIcon={<DownloadIcon />}
                size="small"
                sx={{ ml: 1 }}
            >
                Exportar
            </Button>
            <Backdrop
                sx={{
                    color: '#fff',
                    zIndex: (theme) => theme.zIndex.drawer + 9999,
                    backdropFilter: 'blur(5px)',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)'
                }}
                open={exporting}
            >
                <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
                    <CircularProgress color="primary" size={50} thickness={4} />
                    <Typography variant="h6" sx={{ fontWeight: 500 }}>
                        Generando archivo
                    </Typography>
                    <Typography variant="body2" sx={{ opacity: 0.8 }}>
                        Por favor espere, procesando datos...
                    </Typography>
                </Box>
            </Backdrop>
        </>
    );
};

export default SacopExportButton;
